import { BadgeComponent } from './Badge';
import { badgeBaseDefinition } from './badge.common';
import styles from './Badge.styles.scss';
export const badgeDefinition = badgeBaseDefinition('badge', styles);
export const chameleonBadge = BadgeComponent.compose(badgeDefinition);
